// extracted by mini-css-extract-plugin
export default {"container":"MapLink_container__9ou0o","icon":"MapLink_icon__80NpM"};